import { useCallback, useEffect, useMemo, useState } from 'react';
import userContextUtils from 'utils/userContextUtils';
import { useSelector, useDispatch } from 'react-redux';
import { useCIAMHistory, useRealm, useCIAMContextParam } from 'ciam-self-service-shared';
import useGoToUrl from '../../../hooks/useGoToUrl';
import { useIntl } from 'react-intl';

export default function useSelectChannel(onSelectChannel) {
  const dispatch = useDispatch();
  const history = useCIAMHistory();
  const [displayChoices, setDisplayChoices] = useState(false);
  const stage = useSelector((state) => state.loginInfo.stage);
  const userContext = useSelector((state) => state.loginInfo.userContext);
  const channels = useMemo(() => userContextUtils.getChannels(userContext), [userContext]);
  const realm = useRealm();
  const brand = useCIAMContextParam('brand');
  const gotoURI = useGoToUrl();
  const intl = useIntl();
  const { locale } = intl;

  const handleSelectChannel = useCallback(
    (selectedChannel) => {
      const payload = {
        stage,
        otpchannel: selectedChannel.value,
        history,
        realm,
        locale,
        brand,
        gotoURI,
      };
      onSelectChannel(dispatch, payload, selectedChannel);
    },
    [onSelectChannel, dispatch, history, stage, brand, gotoURI, realm, locale],
  );

  useEffect(() => {
    const shouldAutoSelect = channels?.length === 1;
    const shouldDisplayChoices = channels?.length > 1;

    setDisplayChoices(shouldDisplayChoices);

    if (shouldAutoSelect) {
      handleSelectChannel(channels[0]);
    }
  }, [handleSelectChannel, channels]);

  return [channels, handleSelectChannel, displayChoices];
}
